import { render, staticRenderFns } from "./RemoveFollowerConfig.vue?vue&type=template&id=268c8b01&scoped=true"
import script from "./RemoveFollowerConfig.vue?vue&type=script&lang=js"
export * from "./RemoveFollowerConfig.vue?vue&type=script&lang=js"
import style0 from "./RemoveFollowerConfig.vue?vue&type=style&index=0&id=268c8b01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268c8b01",
  null
  
)

export default component.exports